
<t-row class="permissions-table-row">
  <t-column class="permissions-table-row-header">
    <div>
      <span v-tooltip="property.defaultLabelTitle" class="row-header-selector header-text inline-block">
        {{ property.defaultLabelTitle }}
      </span>
      <sensitive-data-icon v-if="propertyIsSecurityTagged" class="pl-1"></sensitive-data-icon>
    </div>
  </t-column>
  <t-column v-for="permittee in permissionsTablePermittees" :key="`${property.client_id}_${permittee.client_id}`" size="">
    <row>
      <input
          :id="`edit_property_permission_${property.client_id}_${permittee.client_id}`"
          type="checkbox"
          @input="createDestroyPermission(permittee, property, ObjectModelPermissionCapabilityType.Edit)"
          :checked="!!permissionFor(permittee, property, ObjectModelPermissionCapabilityType.Edit)"
      >
      <label :for="`edit_property_permission_${property.client_id}_${permittee.client_id}`">
        Edit
      </label>
    </row>
  </t-column>
  <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_cell_${index}`" size=""><row>&nbsp;</row></t-column>
</t-row>
